import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { DemolitionData } from '../types';
import { TableHeader } from './TableHeader';

interface ConvertedDemolitionData {
  date: Date;
  house: string;
  street: string;
  cost: number;
  cd: number;
  boro: string;
  dateString: string;
  costString: string;
}
interface PropTypes {
  demolitionData: DemolitionData[];
}

const TableRow = ({ demolitionData }: { demolitionData: ConvertedDemolitionData }) => (
  <Table.Row>
    <Table.Cell collapsing>{demolitionData.dateString}</Table.Cell>
    <Table.Cell collapsing>{demolitionData.house}</Table.Cell>
    <Table.Cell collapsing>{demolitionData.street}</Table.Cell>
    <Table.Cell collapsing>{demolitionData.costString}</Table.Cell>
    <Table.Cell collapsing>{demolitionData.cd}</Table.Cell>
    <Table.Cell collapsing>{demolitionData.boro}</Table.Cell>
  </Table.Row>
);

const DemolitionDataTab = (props: PropTypes) => {
  const [sortedDemolitionData, setSortedDemolitionData] = useState<ConvertedDemolitionData[]>([]);

  const parseDateFromString = (dateString: string) => {
    const dateParts = dateString.split('/');
    if (dateParts.length === 3) {
      const month = parseInt(dateParts[0]) - 1;
      const day = parseInt(dateParts[1]);
      const year = parseInt(dateParts[2]);
      return new Date(year, month, day);
    }
    return null;
  };

  const parseCostNumberFromString = (costString: string) => {
    const numberString = costString.replace(/[$,]/g, '');
    return parseFloat(numberString);
  };

  useEffect(() => {
    if (props.demolitionData) {
      setSortedDemolitionData(
        props.demolitionData.map(d => ({
          ...d,
          street: d.streetName,
          dateString: d.date,
          date: parseDateFromString(d.date),
          cd: parseInt(d.cd),
          cost: parseCostNumberFromString(d.cost),
          costString: d.cost,
        }))
      );
    }
  }, [props.demolitionData]);
  return (
    <React.Fragment>
      {sortedDemolitionData.length === 0 ? (
        <div>No Records Available</div>
      ) : (
        <Table striped columns={12} sortable>
          <TableHeader
            columnNames={['Date', 'House', 'Street', 'Cost', 'CD', 'Boro']}
            sortedData={sortedDemolitionData}
            setSortedData={setSortedDemolitionData}
          />
          <Table.Body>
            {sortedDemolitionData.map(hf => (
              <TableRow demolitionData={hf} />
            ))}
          </Table.Body>
        </Table>
      )}
    </React.Fragment>
  );
};

export default DemolitionDataTab;
